import { createSlice } from '@reduxjs/toolkit';

import type { Loadable } from '../../models/loadable.model';
import { emptyLoadable } from '../../models/loadable.model';
import type { Product } from '../../shopify/models/product.model';
import type { Attachable } from '../models/attachable.model';
import { emptyAttachable } from '../models/attachable.model';
import { loadProduct } from './element.thunk';

export interface IElementState {
  loadingSection: Attachable<HTMLElement>;
  contentDiv: Attachable<HTMLElement>;
  hiddenWhileLoadingSection: Attachable<HTMLElement[]>;
  product: Loadable<Product | null>;
}

export const initialState: IElementState = {
  loadingSection: emptyAttachable(),
  contentDiv: emptyAttachable(),
  hiddenWhileLoadingSection: emptyAttachable(),
  product: emptyLoadable(),
};

const elementSlice = createSlice({
  name: 'element',
  initialState,
  reducers: {
    resetContent: () => initialState,
  },
  extraReducers: (builder) => {
    // ========== Load Product ==========
    builder
      .addCase(loadProduct.pending, (state: IElementState) => {
        state.product.loading = true;
        state.product.loaded = false;
        state.product.error = undefined;
      })
      .addCase(loadProduct.fulfilled, (state: IElementState, action) => {
        state.product.loading = false;
        state.product.loaded = true;
        state.product.value = action.payload;
        state.product.error = undefined;
      })
      .addCase(loadProduct.rejected, (state: IElementState, action) => {
        state.product.loading = false;
        state.product.loaded = false;
        state.product.error = action.payload;
      });
  },
});

export const { resetContent } = elementSlice.actions;
export const elementReducer = elementSlice.reducer;
